module.exports = __webpack_public_path__ + "img/Whoop Strap 4.0 (Dispositivo).64c72389.jpg";